import { Link } from 'react-router-dom';
import LinkIcon from '@mui/icons-material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { openOsr, openPrac, openSge, openEplans } from './app-opener';
import { useTheme } from '@mui/material/styles';

const LinkOsr = ({ ref }) => {
    const theme = useTheme();
    return ref ? (
        <>
            {ref}
            <Link to="#" onClick={() => openOsr(ref)}>
                <OpenInNewIcon sx={{ color: theme.palette.primary.main, ml: 1, verticalAlign: 'middle', fontSize: '100%' }} />
            </Link>
        </>
    ) : null;
};

const LinkPrac = ({ ref }) => {
    const theme = useTheme();
    return ref ? (
        <>
            {ref}
            <Link to="#" onClick={() => openPrac(ref)}>
                <OpenInNewIcon sx={{ color: theme.palette.primary.main, ml: 1, verticalAlign: 'middle', fontSize: '100%' }} />
            </Link>
        </>
    ) : null;
};

const LinkSge = ({ ref }) => {
    const theme = useTheme();
    return ref ? (
        <>
            {ref}
            <Link to="#" onClick={() => openSge(ref)}>
                <OpenInNewIcon sx={{ color: theme.palette.primary.main, ml: 1, verticalAlign: 'middle', fontSize: '100%' }} />
            </Link>
        </>
    ) : null;
};

const LinkEplans = ({ ref }) => {
    const theme = useTheme();
    return ref ? (
        <>
            E-Plans: {ref}
            <Link to="#" onClick={() => openEplans(ref)}>
                <OpenInNewIcon sx={{ color: theme.palette.primary.main, ml: 1, verticalAlign: 'middle', fontSize: '100%' }} />
            </Link>
        </>
    ) : null;
};

export { LinkOsr, LinkPrac, LinkSge, LinkEplans };